import { Box } from "@mui/material";
import { ReactNode } from "react";

export interface RadioCardOption {
  value: string;
  label: ReactNode;
  sub?: string;
  icon?: ReactNode;
}

interface Props {
  value: string;
  onChange: (value: string) => void;
  options: RadioCardOption[];
  columns?: number;
  layout?: "card" | "row";
}

// TODO: deprecar por el componente ChoiceToggle
export const RadioCardGroup = ({ value, onChange, options, columns = 2, layout = "card" }: Props) => (
  <Box sx={{ display: "grid", gridTemplateColumns: `repeat(${columns}, 1fr)`, gap: 1.5 }}>
    {options.map((opt) => {
      const on = value === opt.value;
      return (
        <Box
          key={opt.value}
          onClick={() => onChange(opt.value)}
          sx={{
            display: "flex",
            alignItems: layout === "card" ? "flex-start" : "center",
            gap: 1.5,
            p: layout === "card" ? 2 : 1.5,
            border: "1.5px solid",
            borderColor: on ? "primary.main" : "primary.light",
            borderRadius: 2,
            cursor: "pointer",
            bgcolor: on ? "primary.base" : "background.paper",
            transition: "all .15s ease",
          }}
        >
          {opt.icon && <Box sx={{ color: on ? "primary.main" : "primary.light", display: "flex" }}>{opt.icon}</Box>}
          <Box sx={{ flex: 1 }}>
            <Box sx={{ fontWeight: 600, fontSize: 13.5, color: on ? "primary.dark" : "text.primary" }}>{opt.label}</Box>
            {opt.sub && <Box sx={{ fontSize: 12, color: "text.secondary", mt: 0.25 }}>{opt.sub}</Box>}
          </Box>
        </Box>
      );
    })}
  </Box>
);
